import { useChat } from '../../context/useChat'
import { useNls } from '../../nls/nlsProvider'
import styles from './chat.module.css'

const MAX_VISIBLE = 4

const initialsOf = (name: string) =>
  name
    .split(' ')
    .map((part) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase()

export const HuddleStrip = () => {
  const { huddlePresence } = useChat()
  const { t } = useNls()
  if (huddlePresence.length === 0) return null
  const visible = huddlePresence.slice(0, MAX_VISIBLE)
  const overflow = huddlePresence.length - visible.length

  return (
    <div className={styles.huddleStrip} role="group" aria-label={t('NLSChatHuddleParticipantsAria')}>
      {visible.map((presence) => (
        <span
          key={presence.uid}
          className={`${styles.huddleAvatar} ${presence.isSpeaking ? styles.huddleAvatarSpeaking : ''}`}
          title={presence.displayName}
        >
          {presence.photoURL
            ? <img src={presence.photoURL} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            : initialsOf(presence.displayName)}
        </span>
      ))}
      {overflow > 0 && (
        <span className={styles.huddleOverflow} aria-label={t('NLSChatAriaMoreParticipants', { count: overflow })}>
          +{overflow}
        </span>
      )}
    </div>
  )
}
